import { useState, useEffect } from "react"
import { EstadoCivilKeys, IEstadoCivil } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { estadoCivilKeyToLabel } from "../../../detalhes-do-projeto/filtros/estado-civil"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteEstadoCivil = () => {
    // Redux State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedEstadoCivil, setSelectedEstadoCivil] = useState<IEstadoCivil[]>([])

    // Hooks
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        const estadosCivisSelecionados = editRecorteExtracaoForm.fields.Filtros?.estadoCivil || [];

        if (estadosCivisSelecionados.length > 0) {
            setSelectedEstadoCivil(estadosCivisSelecionados);
        } else {
            setSelectedEstadoCivil([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.estadoCivil]);

    const filteredEstadoCivil = EstadoCivilKeys.filter((estadoCivil: IEstadoCivil) =>
        !selectedEstadoCivil.includes(estadoCivil)
    );

    const handleEstadoCivilSelectionChange = (value: IEstadoCivil[]) => {
        setSelectedEstadoCivil(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'estadoCivil',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'estadoCivil',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredEstadoCivil}
                    value={selectedEstadoCivil}
                    getOptionLabel={(option) => estadoCivilKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    onChange={(event, value) => {
                        handleEstadoCivilSelectionChange(value);
                    }}
                    noOptionsText='Nenhum estado civil encontrado'
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de tipos de estado civil"
                        />
                    )}
                />
            </Grid>
        </>
    )
}